module.exports = __webpack_public_path__ + "img/alex-outofbox.25d97697.png";